import React, { useEffect } from "react";
import Header from "../components/Header";
import { Outlet, useParams } from "react-router-dom";
import i18n from "../locales/i18n";
import Footer from "../components/Footer";

const Layout = () => {
  const { lang } = useParams();
  useEffect(() => {
    if (!lang) return;

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
